import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SectionLabel from "../components/SectionLabel";
import Video from "../components/Video";
import { CASE_STUDIES } from "../data/site";

export default function CaseStudies({ onOpen }) {
  const [hover, setHover] = useState(null);
  const active = CASE_STUDIES.find((c) => c.id === hover);

  return (
    <section
      id="cases"
      className="relative overflow-hidden px-6 md:px-12 lg:px-16 py-32 md:py-48"
      data-testid="case-studies"
    >
      {/* background video crossfade on hover */}
      <AnimatePresence>
        {active && (
          <motion.div
            key={active.id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.3 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7 }}
            className="pointer-events-none absolute inset-0 z-0"
          >
            <Video src={active.video} priority className="h-full w-full" />
            <div className="absolute inset-0 bg-black/50" />
          </motion.div>
        )}
      </AnimatePresence>

      <div className="relative z-10">
        <SectionLabel index="09">CASE STUDIES</SectionLabel>
        <h2 className="mt-8 text-huge uppercase max-w-4xl">
          THE WORK BEHIND
          <br />
          THE <span className="text-lav-400">WORK.</span>
        </h2>

        <div className="mt-20 border-t border-white/[0.08]">
          {CASE_STUDIES.map((c) => (
            <motion.button
              key={c.id}
              onMouseEnter={() => setHover(c.id)}
              onMouseLeave={() => setHover(null)}
              onClick={() => onOpen(c.id)}
              data-cursor="VIEW"
              data-testid={`case-row-${c.id}`}
              animate={{ opacity: hover && hover !== c.id ? 0.25 : 1 }}
              className="group grid w-full grid-cols-1 items-center gap-2 border-b border-white/[0.08] py-9 text-left md:grid-cols-[auto_1fr_auto] md:gap-10 md:py-12"
            >
              <span className="label text-lav-400/70">{c.index}</span>
              <div>
                <motion.h3
                  animate={{ x: hover === c.id ? 14 : 0 }}
                  transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                  className="text-big uppercase leading-none group-hover:text-lav-400"
                >
                  {c.client}
                </motion.h3>
                <p className="mt-3 label text-white/45">
                  {c.company} — {c.tagline}
                </p>
              </div>
              <div className="text-left md:text-right">
                <div className="text-3xl md:text-5xl thin text-white">{c.metric}</div>
                <div className="label mt-2 text-white/40">{c.metricLabel}</div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
